module.exports = __webpack_public_path__ + "img/profile.d4212e2d.jpg";